<template>
  <div class="resourcePool">
    <!-- 顶部banner图 -->
    <div class="top-banner-box">
      <div class="top-banner-img">
        <div class="top-banner-center">
        </div>
      </div>
      <!-- 搜索 -->
      <div class="serviceCon">
        <el-row type="flex">
          <el-input placeholder="请输入内容" v-model="params.keyWorld" clearable class="search-input" @clear="getDemandInfoList">
            <template slot="append">
              <div class="btn search-btn" @click="getDemandInfoList">搜索需求</div>  
            </template>
          </el-input>
          <div class="btn collection-btn" @click="goDemandCollection">需求征集</div>
        </el-row>
        <div class="tip">热门查询： <span v-for="item in hotWordList" style="margin-right: 10px;" @click="hotSelect(item.name)" class="curp">{{item.name}}</span></div>
      </div>
    </div>
    <div class="module">
      <div class="module-content" v-loading="loading">
        <div class="form-content">
          <el-row type="flex" class="form-row">
            <div class="label">行业类型：</div>
            <div class="label-value-wrap">
              <div :class="{'label-value': true, active: params.industryType == '' ? true:false}" @click="industrySelect('')">全部</div>
              <div :class="{'label-value': true, active: params.industryType == item.name ? true:false}"
                v-for="item in industryList" @click="industrySelect(item.name)" :key="item.uuid">{{item.name}}</div>
            </div>
          </el-row>
          <el-row type="flex" class="form-row">
            <div class="label">应用场景：</div>
            <div class="label-value-wrap">
              <div :class="{'label-value': true, active: params.applicationScene == '' ? true:false}" @click="caseSelect('')">全部</div>
              <div :class="{'label-value': true, active: params.applicationScene == item.name ? true:false}"
                v-for="item in caseList" @click="caseSelect(item.name)" :key="item.uuid">{{item.name}}</div>
            </div>
          </el-row>
          <el-row type="flex" justify="space-between" class="form-row" align="middle">
            <el-row class="left" type="flex" align="middle">
              <div class="label">排&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 序：</div>
              <div :class="{'label-value': true,  'active': params.sort == item.value}" v-for="item in sortList" @click="sortSelect(item.value)">{{item.name}}</div>
              <div class="label" id="budgetType">预算类型：</div>
              <el-select v-model="params.budgetType" size="mini" placeholder="请选择" clearable @change="getDemandInfoList">
                <el-option
                  v-for="item in budgetTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-row>
            <div class="right">
              <el-switch
                v-model="params.isPass"
                active-text="只看未过期"
                inactive-text=""
                active-value="1"
                inactive-value="0"
                @change="getDemandInfoList">
              </el-switch>
            </div>
          </el-row>
        </div>
        <div class="project-content">
          <div class="project-item" v-for="item in demandInfoList" :key="item.uuid">
            <div :class="{'flag':true, 'active': !isAfterEndDate(item.endDate)}">{{isAfterEndDate(item.endDate) ? '已截至': '进行中'}}</div>
            <div class="title" :title="item.demandName">{{item.demandName}}</div>
            <div class="text company" :title="item.companyName">需求方：{{ item.companyName }}</div>
            <div class="text">联系方式：{{setDimPhone(item.telPhone) }}</div>
            <div class="introduction">
              需求内容：{{item.remark}}
            </div>
            <div class="text">发布时间：{{ item.createDate }}</div>
            <div class="text">截止时间：{{formatDate(item.endDate)}}</div>
            <div class="text">预算金额：<span class="red-text">{{setBudGetText(item)}}</span></div>
            <div class="btn-row">
              <div
                class="btn"
                @mouseenter="hoveredItem = item"
                @mouseleave="hoveredItem = null"
                @click.stop="goDetail(item)">
                {{ hoveredItem === item ? '查看详情' : item.countdownText }}
              </div>
            </div>
          </div>
          <div class="empty-box" v-if="demandInfoList.length == 0">暂无数据</div>
        </div>
        <!-- 分页 -->
        <div style="text-align: center;padding: 30px 0;">
          <el-pagination
            @current-change="getDemandInfoList"
            :current-page="params.current"
            :page-size="params.pageSize"
            background
            layout="prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { demandInfoQuery } from "@/utils/honorApi"
import { getIndexDictionaryData } from "@/utils/interface"
import { setBudGetText, setDimPhone, formatDate } from "@/utils/filter";
export default {
  name: "",
  components: {  },
  props: {},
  data() {
    return {
      params: {
        status: 'REVIEW_PASS',
        keyWorld: '',
        industryType: '',
        applicationScene: '',
        budgetType: '',
        isPass: '0',  // 只看未过期 1：是 0：否
        sort: '',     // 排序 发布时间 截止时间
        userUuid: '',
        current: 1,
        pageSize: 16,
      },
      total: 0,
      demandInfoList: [],
      loading: false,
      hotWordList: [],
      caseList: [],
      industryList: [],
      sortList: [
        { name: '发布时间', value: 'publish' },
        { name: '截至时间', value: '' }
      ],
      budgetTypeList: [
        { value: '0', label: '一口价' },
        { value: '1', label: '预算区间' },
        { value: '2', label: '无项目预算' },
      ],
      hoveredItem: null,   // 记录当前鼠标悬停的项
      timer: null,
      headerBgUrl: "",
      num: 168,
      title: "",

    };
  },
  watch: {},
  computed: {
    itemLoading() {
    }
  },
  beforeRouteEnter(to, from, next) {
    // console.log("to=>", to)
    // console.log("from=>", from)
    // console.log("next=>", next)
    next(vm => {
      if (from.name == "expertDetail") {
        vm.$nextTick(() => {
          window.scrollTo({
            top: document.getElementById("field").offsetTop - 80,
            behavior: "smooth"
          });
        });
      }
    });
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  created() {
    this.getDictionary();
    this.getDemandInfoList();
    // this.getOptionsData();
  },
  mounted() {
    window.addEventListener("scroll", this.menu);
    if (this.$route.query.type || this.$route.query.code) {
      let type = this.$route.query.type;
      let code = this.$route.query.code;
      if (type == "expert" || code == "2") {
        this.timer = setInterval(() => {
          // 直到顶部导航栏加载出来，再去做滑动操作，防止滑动后顶部导航栏颜色还是透明色
          let length = document.querySelectorAll(".changeColor").length;
          if (length > 0) {
            clearInterval(this.timer);
            window.scrollTo({
              top: document.getElementById("field").offsetTop - 80,
              behavior: "smooth"
            });
          }
        });
      }
    }
    if (this.$route.query.title) {
      this.title = this.$route.query.title;
      this.timer = setInterval(() => {
        // 直到顶部导航栏加载出来，再去做滑动操作，防止滑动后顶部导航栏颜色还是透明色
        let length = document.querySelectorAll(".changeColor").length;
        if (length > 0) {
          clearInterval(this.timer);
          window.scrollTo({
            top: document.getElementById("field").offsetTop - 80,
            behavior: "smooth"
          });
        }
      });
    }
  },
  methods: {
    setBudGetText,
    setDimPhone,
    formatDate,
    isAfterEndDate(endDateStr) {
      const endDate = new Date(endDateStr); // 将字符串转为 Date 对象
      const now = new Date();               // 当前时间
      return now >= endDate;
    },
    sortSelect(value) {
      this.params.sort = value;
      this.getDemandInfoList();
    },
    caseSelect(name) {
      this.params.applicationScene = name;
      this.getDemandInfoList();
    },
    industrySelect(name) {
      this.params.industryType = name;
      this.getDemandInfoList();
    },
    startCountdown() {
      // 启动每秒更新一次
      this.timer = setInterval(() => {
        this.demandInfoList.forEach((item, index) => {
          if (!item.endDate) {
            item.countdownText = '查看详情';
            return;
          }
          const endTime = new Date(item.endDate).getTime();
          const now = new Date().getTime();
          const diff = endTime - now; // 毫秒差
          if (diff <= 0) {
            item.countdownText = '查看详情'; // 已过期，不显示
            return;
          }

          // 计算天、时、分、秒
          const days = Math.floor(diff / (1000 * 60 * 60 * 24));
          const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
          const minutes = Math.floor((diff / (1000 * 60)) % 60);
          const seconds = Math.floor((diff / 1000) % 60);

          // 格式化输出：只显示“X天X时X分X秒”，但你可以按需简化
          let text = '';
          if (days > 0) {
            text += `${days}天`;
          }
          if (hours > 0) {
            text += `${hours}时`;
          }
          if (minutes > 0) {
            text += `${minutes}分`;
          }
          if (seconds > 0 || !text) { // 如果前面都没显示，至少保留秒
            text += `${seconds}秒`;
          }

          item.countdownText = '截止时间剩余 ' + text;
          this.$set(this.demandInfoList, index, item);
        });
      }, 1000); // 每秒更新一次
    },
    getDictionary() {
      // 热词查询
      getIndexDictionaryData({
        groupCode: "DEMAND_HOT_GROUP"
      }).then(res => {
        this.hotWordList = res.filter(item => item.survivalCn === "启用");
      });
      // 应用场景字典查询
      getIndexDictionaryData({
        groupCode: "service_provider_case"
      }).then(res => {
        this.caseList = res.filter(item => item.survivalCn === "启用");
      });

      // 行业字典查询
      getIndexDictionaryData({
        groupCode: "service_provider_industry"
      }).then(res => {
        this.industryList = res.filter(item => item.survivalCn === "启用");
      });
    },
    hotSelect(name) {
      this.params.keyWorld = name;
      this.getDemandInfoList();
    },
    getDemandInfoList() {
      if (this.loading) return;
      this.loading = true;
      demandInfoQuery(this.params).then(res => {
        this.demandInfoList = res.list;
        this.total = res.total;
        if (this.timer) clearInterval(this.timer);
        this.startCountdown();
      }).finally(_ => {
        setTimeout(() => {
          this.loading = false;
        }, 1000)
      })
    },
    goDetail(item) {
      this.$router.push({path: "/demandInfoDetail", query: { id: item.uuid }});
    },
    goDemandCollection() {
      const targetPath = '/review_center/#/supplyAndDemand';
      window.open(targetPath, '_blank');
    },
    getOptionsData() {
      //顶部背景图
      getDictionaryItem({
        code: "ZYC_BANNER"
      }).then(res => {
        if (res != null && res.length > 0) {
          this.headerBgUrl = res[0].value;
        } else {
          this.headerBgUrl = "";
        }
      });
    },
    onClickLookMore() {},

    //众多优质服务商-查看更多
    onClickProviderMore() {
      let route = this.$router.resolve({
        path: "/providerList"
      });
      window.open(route.href, "_blank");
    },
    // 获取服务商详情
    serviceDetail(uuid) {
      let routeData = this.$router.resolve({
        path: "/providerDetail",
        query: {
          uuid: uuid
        }
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>
<style lang="less" scoped>
.red-text {
  color: #FF0000;
}
.resourcePool {
  position: relative;
  top: -80px;
  margin-bottom: -80px;

  .curp {
    &:hover {
      cursor: pointer;
      color: #2d50a1;
    }
  }

  .top-banner-box {
    position: relative;
    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      background: url('~@/assets/image/demandInfo_top_bg.png') no-repeat;
      background-size: cover;
      .top-banner-center {
        width: 1300px;
        height: 370px;
        position: relative;
      }
      .btn-row {
        margin-left: 80px;
        // background-color: white;
        display: flex;  
        position: absolute;
        bottom: 45px;
        transition: all 0.2s;
      }
      .btn {
        margin-right: 15px;
        width: 166px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
        font-weight: normal;
        color: #3672F6;
        border-radius: 4px;
        opacity: 1;
        background: rgba(255, 255, 255, 0.4);
        box-sizing: border-box;
        border: 1px solid #3672F6;
        cursor: pointer;
        user-select: none;
        &:first-child {
          background: linear-gradient(90deg, #2D50A1 0%, #6B8DDC 100%);
          color: #FFFFFF;
        }
      }
    }
  }

  .serviceCon {
    padding: 25px 35px 14px;
    width: 1300px;
    height: 132px;
    margin: 0 auto;
    border-radius: 10px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    background-color: #fff;
    position: absolute;
    left: calc(50% - 650px);
    bottom: -55px;
    box-sizing: border-box;
    font-size: 18px;
    font-weight: 350;
    color: #2B2B2B;
    // display: flex;
    // flex-flow: row nowrap;
    // justify-content: space-between;
    // align-items: center;
    .search-input {
        margin-right: 24px;
        margin-bottom: 7px;
        width: 1031px;
        height: 60px;
        /deep/ .el-input__inner {
          height: 100%;
          font-size: 18px;
          font-weight: 350;
        }
        /deep/ .el-input-group__append {
          width: 206px;
          background: #2D50A1;
          color: #FFFFFF;
          font-size: 18px;
          font-weight: bold;
          text-align: center;
          border-radius: 0 10px 10px 0;
          opacity: 0.95;
          cursor: pointer;
        }
    }
    .collection-btn {
      width: 175px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      opacity: 0.95;
      background: #2D50A1;
      font-size: 18px;
      font-weight: bold;
      color: #fff;
      box-sizing: border-box;
      cursor: pointer;
    }
    .serviceItem {
      width: 420px;
      height: auto;
      // border-right: 1px solid #d5dcec;
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;

      &:last-child {
        border-right: none;
      }

      .serviceItem-bg {
        width: 60px;
        height: 70px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .serviceItem-con {
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        margin-left: 20px;

        .serviceItem-con-num {
            font-size: 24px;
            font-weight: bold;
            color: #2B2B2B;
        }

        .serviceItem-con-name {
          font-size: 20px;
          font-weight: 350;
        }
      }
    }
  }

 

}
.form-content {
  .form-row {
    margin: 0 0 12px;
  }
  .label {
    width: auto;
    white-space: nowrap;
    font-size: 18px;
    font-weight: 500;
    &#budgetType{
      margin: 0 0 0 20px; 
    }
  }
  .label-value-wrap {
    display: flex;
    flex-wrap: wrap;
    .label-value {
       margin: 0 10px 10px;
    }
   
  }
  .label-value {
    margin: 0 10px;
    width: auto;
    white-space: nowrap;
    font-size: 16px;
    font-weight: 350;
    cursor: pointer;
    &.active {
      color: #2D50A1;
    }
  }

}
.module {
  width: 100%;
  margin: auto;
  padding: 93px 0 23px;
  box-sizing: border-box;
  background: #f0f4fa;
  .module-title {
    font-size: 28px;
    font-weight: 600;
    text-align: center;
    margin: 20px 0;
  }
  .title {
    font-size: 24px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: 0em;
    font-feature-settings: "kern" on;
    color: #2B2B2B;
  }
  .module-content {
    width: 1300px;
    padding: 30px 15px;
    margin: 0 auto 30px;
    border-radius: 10px;
    background: #fff;
    box-sizing: border-box;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
    .module-title {
      margin-top: 42px;
    }
    .more-btn {
      margin: 0 auto;
      width: 200px;
      height: 50px;
      border-radius: 4px;
      opacity: 1;
      background: #FFFFFF;
      box-sizing: border-box;
      border: 1px solid #2D50A1;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #2D50A1;
      font-size: 16px;
      font-weight: normal;
      cursor: pointer;
    }
    .project-content {
      width: 100%;
      margin: 38px auto 0;
      display: flex;
      flex-wrap: wrap;
    }
    .project-item {
      margin-right: 9px;
      margin-bottom: 22px;
      position: relative;
      width: 310px;
      height: 392px;
      padding: 28px 17px 25px;
      border-radius: 8px;
      opacity: 1;
      background: #FFFFFF;
      font-size: 16px;
      font-weight: 350;
      line-height: normal;
      color: #2B2B2B;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      box-sizing: border-box;
      border: 1px solid rgba(106, 106, 106, 0.2);
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
      &:nth-of-type(4n) { 
        margin-right: 0;
      }
    }
    .flag {
      position: absolute;
      top: 0;
      right: 0;
      width: 70px;
      height: 25px;
      border-radius: 0px 8px 0px 8px;
      opacity: 1;
      background: linear-gradient(270deg, #B0B0B0 2%, #D3D3D3 100%);
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
      font-size: 14px;
      font-weight: 350;
      color: #FFFFFF;
      display: flex;
      justify-content: center;
      align-items: center;
      &.active {
        background: linear-gradient(270deg, #FF0000 0%, #FF7B00 100%);
      }
    }
    .title {
      margin: 3px 0;
      font-size: 24px;
      font-weight: bold;
      line-height: normal;
      white-space: nowrap; /* 禁止文本换行 */
      overflow: hidden; /* 隐藏超出范围的内容 */
      text-overflow: ellipsis; /* 使用省略号 */
    }
    .company {
      white-space: nowrap; /* 禁止文本换行 */
      overflow: hidden; /* 隐藏超出范围的内容 */
      text-overflow: ellipsis; /* 使用省略号 */
    }
    .introduction {
      padding: 11px 11px 14px;
      width: 276px;
      height: 65px;
      border-radius: 4px;
      background: #eaedf5;
      box-sizing: border-box;
      line-height: 1.54;
      display: -webkit-box; /* 设置为WebKit内核的弹性盒子模型 */
      -webkit-box-orient: vertical; /* 垂直排列 */
      -webkit-line-clamp: 2; /* 限制显示三行 */
      overflow: hidden; /* 隐藏超出范围的内容 */
      text-overflow: ellipsis; /* 使用省略号 */
    }
    .btn-row {
      padding-top: 14px;
      border-top: 1px solid #CBCBCB;
      .btn {
        width: 100%;
        height: 48px;
        border-radius: 4px;
        background: linear-gradient(90deg, #2D50A1 0%, #6B8DDC 100%);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .product-content {
    padding-bottom: 10px;
    position: relative;
    width: 1300px;
    margin: auto !important;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .row {
      display: flex;
      justify-content: space-between;
      &:first-of-type {
        margin-bottom: 20px;
      }
    }
  }
  .module-content.scene {
    display: flex;
    .scene-item {
      width: 25%;
      padding: 0 40px;
    }
    .title {
      margin: 14px 0;
    }
    .text {
      font-size: 18px;
      font-weight: 350;
    }
    .btn  {
      margin: 14px 0;
      color: #2D50A1;
      font-size: 18px;
      font-weight: 350;
    }
  }
  .product-item {
    background: linear-gradient(90deg, #EEF4FF 0%, #F4F7FD 100%);
    box-sizing: border-box;
    border: 1px solid #FFFFFF;
    border-radius: 8px;
    width: calc(33% - 15px);
    margin-bottom: 20px;
    padding: 25px 30px;
    &:nth-of-type(1), &:nth-of-type(2) {
      width: calc(50% - 15px);
    }
    &:nth-of-type(4), &:nth-of-type(5) {
    
    }
    .btn {
        width: 80px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 18px;
        font-weight: 350;
        background: linear-gradient(270deg, #FF0000 0%, #FF7B00 100%);
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
        box-sizing: border-box;
        border-radius: 302px;
    }
  }
}

.btn {
  cursor: pointer;
}
/deep/ .el-carousel__arrow--left {
  left: 90px;
}

/deep/ .el-carousel__arrow--right {
  right: 90px;
}
.empty-box {
  height: 300px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a2a2a2;
}
</style>



// WEBPACK FOOTER //
// src/components/demandInfo/demandInfoList.vue